import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';

import CloseIcon from '@/assets/icons/close-icon.svg';
import AdvantageClub from '@/assets/images/partners/advantage-club.png';
import BajajFinserv from '@/assets/images/partners/bajaj-finserv.png';
import Cibil from '@/assets/images/partners/cibil.png';
import Cred from '@/assets/images/partners/cred.png';
import Experian from '@/assets/images/partners/experian.png';
import Finbox from '@/assets/images/partners/finbox.png';
import Finnone from '@/assets/images/partners/finnone.png';
import Flobiz from '@/assets/images/partners/flobiz.png';
import Leegality from '@/assets/images/partners/leegality.png';
import LoanTap from '@/assets/images/partners/loantap.png';
import Mail from '@/assets/images/partners/mail.svg';
import Map from '@/assets/images/partners/map.svg';
import MoneyTap from '@/assets/images/partners/moneytap.png';
import NamasteCredit from '@/assets/images/partners/namaste-credit.png';
import Solv from '@/assets/images/partners/solv.png';
import Valuemedi from '@/assets/images/partners/valuemedi.png';
import VantageCircle from '@/assets/images/partners/vantage-circle.png';
import Web from '@/assets/images/partners/web.svg';
import Zoop from '@/assets/images/partners/zoop.png';
import useMediaQuery from '@/common/components/Partners/hooks/useMediaQueryHook';
import PartnersCarousel from '@/common/components/Partners/PartnersCarousel';

// import "@/styles/partners/partners-scoped.css";

// Conflict

const Partners = () => {
  const partners = {
    'gold-loan': [
      {
        image: <Image src={LoanTap} alt="Lending Cart Logo" />,
        title: 'LoanTap',
        description:
          'LoanTap is an online platform committed to deliver flexible loan products to salaried professionals. We innovate in an otherwise dull loan segment, to deliver smart products for millennials. The idea is to use technology for building flexibility in products, without adding cost to it.',
        partnerWebsite: 'https://loantap.in/',
        email: 'cs.fintech@loantap.in ',
        address: null,
        category: 'Gold Loan',
      },
      {
        image: <Image src={MoneyTap} alt="Lending Cart Logo" />,
        title: 'MoneyTap',
        description:
          "MoneyTap is India's first app-based credit line, provided in collaboration with leading banks. It's not just a personal loan or credit card but a personal credit line. It offers flexibility with zero collateral and no guarantors required.",
        partnerWebsite: 'https://www.moneytap.com/',
        email: null,
        address: null,
        category: 'Gold Loan',
      },
      {
        image: <Image src={BajajFinserv} alt="Lending Cart Logo" />,
        title: 'BajajFinserv',
        description:
          "Bajaj Finserv is the financial division of the Bajaj group, committed to excellence. They offer a wide range of financial products, including lending, insurance, and wealth advisory services. They are one of India's fastest-growing and most diversified NBFCs.",
        partnerWebsite: 'https://www.bajajfinservmarkets.in/',
        email: 'grievanceofficer@bajajfinservmarkets.in',
        address: null,
        category: 'Gold Loan',
      },
    ],
    dg: [
      {
        image: <Image src={AdvantageClub} alt="Lending Cart Logo" />,
        title: 'Advantage Club',
        description:
          'Advantage Club is a global employee engagement platform, uniting rewards, recognition, community building, and FlexBen. With 10,000+ brand partners, it offers exclusive privileges and aims to revolutionize employee recruitment and retention through comprehensive engagement solutions.',
        partnerWebsite: 'https://www.advantageclub.co/',
        email: null,
        category: 'eSwarna Digital Gold',
        address:
          'India- 14 Floor, Unit No. 1402 Tower C, Unitech Cyber Park Sector 39, Gurugram, Haryana 122003, Contact Number: +91-8882-870-870',
      },
      {
        image: <Image src={VantageCircle} alt="Lending Cart Logo" />,
        title: 'Vantage Circle',
        description:
          'Vantage Circle offers a comprehensive Employee Engagement Suite, featuring Vantage Rewards, Vantage Fit, Vantage Pulse, and Vantage Perks. Trusted by 700+ global organizations, including Fortune 500 companies, our solutions enhance recognition culture, employee well-being, feedback gathering, and benefits.',
        partnerWebsite: 'https://www.vantagecircle.com/',
        email: null,
        category: 'eSwarna Digital Gold',
        address:
          'C1-1151/Vasant Kunj, New Delhi – 110070 ,support@vantagecircle.com',
      },
      {
        image: <Image src={Cred} alt="Lending Cart Logo" />,
        title: 'Cred',
        description:
          'Cred is your partner in responsible credit management. Cred simplifies credit card payments and enhance them with exclusive rewards, personalized insights, and tailored recommendations. With millions of trusted members, Cred has established a secure and efficient platform that turns transactions into opportunities to save and earn.',
        partnerWebsite: 'https://cred.club/',
        email: null,
        category: 'eSwarna Digital Gold',
        address:
          '1198-1199, 3rd Floor, Salarpuria Emporium, 100 Feet Rd, HAL 2nd Stage, Doopanahalli, Indiranagar, Bengaluru, Karnataka 560038',
      },
    ],
    msme: [
      {
        image: <Image src={Valuemedi} alt="Lending Cart Logo" />,
        title: 'ValueMedi',
        description:
          'ValueMedi is dedicated to optimizing pharmaceutical distribution with a focus on speed and efficiency. ValueMedi’s innovative solutions address the challenges in the industry, ensuring swift and streamlined processes for the timely delivery of pharmaceutical products, ultimately enhancing healthcare accessibility worldwide.',
        partnerWebsite: null,
        email: null,
        category: 'MSME',
        address: null,
      },
      {
        image: <Image src={Flobiz} alt="Lending Cart Logo" />,
        title: 'Flobiz',
        description:
          'FloBiz is a neobank for SMBs revolutionizing business with technology. Their flagship product, myBillBook, enables seamless invoicing, accounting, and workflow automation for over a million monthly users, recording $1 billion in transactions monthly, and supporting multiple languages. Fueling economic growth for aspiring SMB owners.',
        partnerWebsite: null,
        category: 'MSME',
        email: null,
        address: null,
      },
      {
        image: <Image src={Solv} alt="Lending Cart Logo" />,
        title: 'Solv',
        description:
          "Solv is India's trusted B2B e-commerce platform, dedicated to empowering over 65 million MSMEs, integral to 30% of India's GDP. Using advanced AI & ML technology, Solv digitizes B2B supply chains, fostering growth for MSMEs through a seamless and efficient e-commerce marketplace.",
        partnerWebsite: null,
        email: null,
        category: 'MSME',
        address: null,
      },
    ],
    tech: [
      {
        image: <Image src={Cibil} alt="Lending Cart Logo" />,
      },
      {
        image: <Image src={Experian} alt="Lending Cart Logo" />,
      },
      {
        image: <Image src={Zoop} alt="Lending Cart Logo" />,
      },
      {
        image: <Image src={Leegality} alt="Lending Cart Logo" />,
      },
      {
        image: <Image src={Finnone} alt="Lending Cart Logo" />,
      },
      {
        image: <Image src={NamasteCredit} alt="Lending Cart Logo" />,
      },
      {
        image: <Image src={Finbox} alt="Lending Cart Logo" />,
      },
    ],
  };

  const [partnerInfoCat, setPartnerInfoCat] =
    useState<keyof typeof partners>('gold-loan');
  const [partnerInfoIndex, setPartnerInfoIndex] = useState(0);

  const partnerRef = useRef<HTMLDivElement>(null);
  const glRef = useRef<HTMLDivElement>(null);
  const dgRef = useRef<HTMLDivElement>(null);
  const msmeRef = useRef<HTMLDivElement>(null);
  const techRef = useRef<HTMLDivElement>(null);

  const [currentSection, setCurrentSection] = useState('gl');

  const isMobile = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    const onScroll = () => {
      if (!isMobile) {
        if (
          glRef.current?.getBoundingClientRect().top &&
          glRef.current?.getBoundingClientRect().top < 10
        ) {
          setCurrentSection('gl');
        }
        if (
          dgRef.current?.getBoundingClientRect().top &&
          dgRef.current?.getBoundingClientRect().top < 10
        ) {
          setCurrentSection('dg');
        }
        if (
          msmeRef.current?.getBoundingClientRect().top &&
          msmeRef.current?.getBoundingClientRect().top < 10
        ) {
          setCurrentSection('msme');
        }
        if (
          techRef.current?.getBoundingClientRect().top &&
          techRef.current?.getBoundingClientRect().top < 10
        ) {
          setCurrentSection('tech');
        }
      }
    };
    // clean up code
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="withHeader scroll-padding">
      <div className="bg bg--dark static-banner-partners">
        <div className="container">
          <div className="partners-heading " ref={partnerRef}>
            <p className="partners-heading-text">Our Partners</p>
            <div className="partners-type-container">
              <a
                href="partners#gl"
                className={`badge-white ${
                  currentSection == 'gl' ? 'badge-active' : ''
                }`}
              >
                <p className="partners-badge">Gold Loan</p>
              </a>
              <a
                href="partners#dg"
                className={`badge-white ${
                  currentSection == 'dg' ? 'badge-active' : ''
                }`}
              >
                <p className="partners-badge">eSwarna Digital Gold</p>
              </a>
              {/* <div className="badge-white ">
                <div className="partners-badge">Forex</div>
              </div>
              <div className="badge-white ">
                <div className="partners-badge">Insurance</div>
              </div> */}
              <a
                href="partners#msme"
                className={`badge-white ${
                  currentSection == 'msme' ? 'badge-active' : ''
                }`}
              >
                <p className="partners-badge">MSME</p>
              </a>
              <a
                href="partners#tech"
                className={`badge-white ${
                  currentSection == 'tech' ? 'badge-active' : ''
                }`}
              >
                <p className="partners-badge">Tech</p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="bg bg--dark dummy-div"></div>

      {isMobile && (
        <div className="d-lg-none partners-bg padding-top-300 container">
          <span className="jumptarget" id="gl" ref={glRef}></span>
          <div className="partners__container">
            <PartnersCarousel
              setPartnerInfoCat={setPartnerInfoCat}
              setPartnerInfoIndex={setPartnerInfoIndex}
              title="Gold Loan"
              partners={partners['gold-loan']}
              cat="gold-loan"
            />
          </div>

          <span className="jumptarget" id="dg" ref={dgRef}></span>
          <div className="partners__container">
            <PartnersCarousel
              title="eSwarna Digital Gold"
              setPartnerInfoCat={setPartnerInfoCat}
              setPartnerInfoIndex={setPartnerInfoIndex}
              partners={partners.dg}
              cat="dg"
            />
          </div>

          <span className="jumptarget" id="msme" ref={msmeRef}></span>
          <div className="partners__container">
            <PartnersCarousel
              title="MSME"
              setPartnerInfoCat={setPartnerInfoCat}
              setPartnerInfoIndex={setPartnerInfoIndex}
              partners={partners.msme}
              cat="msme"
            />
          </div>
        </div>
      )}

      <div className="partners-bg">
        {!isMobile && (
          <>
            <span className="jumptarget" id="gl" ref={glRef}></span>
            <div className="partners-cont-desk container mt-0">
              <div className="partners-desk-container">
                <p className="partners-heading-desk">
                  Gold Loan <span>Partners</span>
                </p>
              </div>
              <div className="partners-grid">
                {partners['gold-loan'].map((part, index) => {
                  return (
                    <div key={index} className="partner-carousel-card-desk">
                      <div className="partner-img-container">{part.image}</div>
                      <div className="partner-content">
                        <div>
                          <span className="partner-content-title">
                            {part.title}
                          </span>
                          <p className="partner-content-p">
                            {part.description}
                          </p>
                        </div>
                        <a
                          href={'#'}
                          onClick={() => {
                            setPartnerInfoCat('gold-loan');
                            setPartnerInfoIndex(index);
                          }}
                          data-toggle="modal"
                          data-target="#abccc"
                          className="partner-content-viewmore"
                        >
                          View More
                        </a>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <span className="jumptarget" id="dg" ref={dgRef}></span>
            <div className="partners-cont-desk container ">
              <div className="partners-desk-container">
                <p className="partners-heading-desk">
                  eSwarna Digital Gold <span>Partners</span>
                </p>
              </div>
              <div className="partners-grid">
                {partners.dg.map((part, index) => {
                  return (
                    <div key={index} className="partner-carousel-card-desk">
                      <div className="partner-img-container">{part.image}</div>
                      <div className="partner-content">
                        <div>
                          <span className="partner-content-title">
                            {part.title}
                          </span>
                          <p className="partner-content-p">
                            {part.description}
                          </p>
                        </div>
                        <a
                          href={'#'}
                          onClick={() => {
                            setPartnerInfoCat('dg');
                            setPartnerInfoIndex(index);
                          }}
                          data-toggle="modal"
                          data-target="#abccc"
                          className="partner-content-viewmore"
                        >
                          View More
                        </a>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <span className="jumptarget" id="msme" ref={msmeRef}></span>
            <div className="partners-cont-desk container">
              <div className="partners-desk-container">
                <p className="partners-heading-desk">
                  MSME <span>Partners</span>
                </p>
              </div>
              <div className="partners-grid">
                {partners.msme.map((part, index) => {
                  return (
                    <div key={index} className="partner-carousel-card-desk">
                      <div className="partner-img-container">{part.image}</div>
                      <div className="partner-content">
                        <div>
                          <span className="partner-content-title">
                            {part.title}
                          </span>
                          <p className="partner-content-p">
                            {part.description}
                          </p>
                        </div>
                        <a
                          href={'#'}
                          onClick={() => {
                            setPartnerInfoCat('msme');
                            setPartnerInfoIndex(index);
                          }}
                          data-toggle="modal"
                          data-target="#abccc"
                          className="partner-content-viewmore"
                        >
                          View More
                        </a>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        )}

        <span className="jumptarget" id="tech" ref={techRef}></span>
        <div className="no-padding container">
          <div className="partners-tech-images">
            <div className="partners-desk-container">
              <p className="partners-heading-desk">
                Tech <span>Partners</span>
              </p>
            </div>
            <div className="partners-grid">
              {partners.tech.map((part, index) => {
                return (
                  <div key={index} className="partner-carousel-card-desk">
                    <div className="partner-img-container img-no-border">
                      {part.image}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal loanDetails__modal addressDetail__modal fade"
        id="abccc"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="addressDetailPopLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg partner-modal" role="document">
          <div className="modal-content partner-modal-content">
            <div className="modal__title partnership-close-icon">
              <a href="" data-dismiss="modal">
                <Image
                  style={{ color: undefined }}
                  className="img-fluid"
                  src={CloseIcon}
                  alt="close icon"
                />
              </a>
            </div>

            {/* Content */}
            <div className="partner-details-mob">
              <div className="d-flex justify-content-between align-items-center partner-border-blue">
                <div className="partner-detail-name">
                  <span>
                    {(partners[partnerInfoCat][partnerInfoIndex] as any).title}
                  </span>
                  <span>
                    {
                      (partners[partnerInfoCat][partnerInfoIndex] as any)
                        .category
                    }{' '}
                    Partner
                  </span>
                </div>
                {(partners[partnerInfoCat][partnerInfoIndex] as any).image}
              </div>
              {(!!(partners[partnerInfoCat][partnerInfoIndex] as any).email ||
                !!(partners[partnerInfoCat][partnerInfoIndex] as any).address ||
                !!(partners[partnerInfoCat][partnerInfoIndex] as any)
                  .partnerWebsite) && (
                <div className="partner-grievance-mob partner-border-blue">
                  <span className="partner-grievance-header">
                    Grievance/redressal details
                  </span>
                  {(partners[partnerInfoCat][partnerInfoIndex] as any)
                    .address && (
                    <div className="partner-det">
                      <div className="d-flex align-items-center">
                        <Image src={Map} alt="Address" />
                        <span className="partner-add ml-2">Address</span>
                      </div>
                      <span>
                        {
                          (partners[partnerInfoCat][partnerInfoIndex] as any)
                            .address
                        }
                      </span>
                    </div>
                  )}
                  {(partners[partnerInfoCat][partnerInfoIndex] as any)
                    .email && (
                    <div className="partner-det">
                      <div className="d-flex align-items-center">
                        <Image src={Mail} alt="Address" />
                        <span className="partner-add ml-2">Email</span>
                      </div>
                      <span>
                        <a
                          href={`mailto:${
                            (partners[partnerInfoCat][partnerInfoIndex] as any)
                              .email
                          }`}
                        >
                          {
                            (partners[partnerInfoCat][partnerInfoIndex] as any)
                              .email
                          }
                        </a>
                      </span>
                    </div>
                  )}
                  {(partners[partnerInfoCat][partnerInfoIndex] as any)
                    .partnerWebsite && (
                    <div className="partner-det">
                      <div className="d-flex align-items-center">
                        <Image src={Web} alt="Address" />
                        <span className="partner-add ml-2">Website</span>
                      </div>
                      <span>
                        <a
                          href={
                            (partners[partnerInfoCat][partnerInfoIndex] as any)
                              .partnerWebsite
                          }
                        >
                          {
                            (partners[partnerInfoCat][partnerInfoIndex] as any)
                              .partnerWebsite
                          }
                        </a>
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Partners;
